//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ADO',
  data () {
    return {
      defaultJson: {
        "ADO Index": "ADO 指数",
        "Patients with longstanding and severe COPD": "长期重度 COPD 患者",
        "Dyspnea Scale": "呼吸困难分级",
        "FEV₁ (% predicted)": "FEV₁（% 预测值）",
        "3-yr Mortality": "三年死亡率",
        "Patients after first hospital admission due to moderate-to-severe COPD": "因中重度 COPD 首次住院治疗的患者",
        "Age": "年龄"
      },
      form: {
        mrcdyspnea:'',
        f:'',
        a:'',
      },
      hasScore: false,
      disabled: false,
      descTxt:'长期重度 COPD 患者',
      descTxt1:'因中重度 COPD 首次住院治疗的患者',
      gmortalityLong:'--',
      mortalityFirst:'--',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.mortalityFirst = '--'
        self.gmortalityLong = '--'
        return '--'
      } else {
        console.log(form)
        	// (a >= 90 ? 5 : (a >= 80 ? 4 : (a >= 70 ? 3 : (a >= 60 ? 2 : (a >= 50 ? 1: 0))))) + 		(f <= 35 ? 2 : (f <= 64 ? 1 : 0)) +		(mrcdyspnea > 3 ? 3 : (mrcdyspnea > 2 ? 2 : (mrcdyspnea > 1 ? 1 : 0)))
        //  form.
        let result = (form.a >= 90 ? 5 : (form.a >= 80 ? 4 : (form.a >= 70 ? 3 : (form.a >= 60 ? 2 : (form.a >= 50 ? 1: 0))))) + 		(form.f <= 35 ? 2 : (form.f <= 64 ? 1 : 0)) +		(form.mrcdyspnea > 3 ? 3 : (form.mrcdyspnea > 2 ? 2 : (form.mrcdyspnea > 1 ? 1 : 0)))
        // (0.9368 * g) + (0.7326 * p) + (0.2908 * r)
        let gmortalityLongObj = {0: 7.2,
          1: 9.9,
          2: 13.5,
          3: 18.1,
          4: 23.9,
          5: 30.8,
          6: 38.7,
          7: 47.2,
          8: 55.9,
          9: 64.2,
          10: 71.8
        }
        let mortalityFirstObj = {
          0: 3,
          1: 4,
          2: 5.4,
          3: 7.3,
          4: 9.8,
          5: 12.9,
          6: 16.9,
          7: 21.8,
          8: 27.6,
          9: 34.3,
          10: 41.7
        }
        self.mortalityFirst = String(mortalityFirstObj[result]|| '') 
        self.gmortalityLong = String(gmortalityLongObj[result]|| '') 

        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/ADO.vue